var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useEffect } from 'react';
import { useDependencyList } from '../useDependencyList/useDependencyList';
export const useUpdate = (callback, dependencyList, comparator) => {
    _react_refresh_temp_1();
    const dependencies = useDependencyList(dependencyList, comparator);
    useEffect(() => {
        const result = callback();
        return () => {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Intentional
            (async () => {
                const func = await result;
                if (typeof func === 'function') {
                    // eslint-disable-next-line @typescript-eslint/await-thenable -- Intentional
                    await func();
                }
            })();
        };
    }, dependencies);
};
_react_refresh_temp_1(useUpdate, "ywUAHOPXb9T9SG5NyWc8L3mAXm0=", false, () => [useDependencyList]);
